import React, { Component } from 'react';

import Icon from 'react-svg-use-icon';

import Vimeo from 'react-vimeo';
import YouTube from 'react-youtube';





class App extends Component {

  scrollTo(to) {
    window.scrollBy({
        top: to,
        //left: 0,
        behavior: 'smooth'
    });
  }

  render() {

    const iconConfig = {
      iconSVG:'./img/svg/icons.0.1.1.min.svg'
    };

    return (
      <div className="App">
        <div id="cover" className="App-header">
          <div className="hello">
            <img src="assets/img/logo.svg" className="App-logo" alt="JP Logo" />
            <h2>Hello.<br /><br />You have discovered the work of<br />JP de Vries</h2>

            <a href="#intro" className="comfortable button" onClick={(event) => {
                try { 
                  this.scrollTo(document.getElementById('intro').getBoundingClientRect().top - this.sticky.getBoundingClientRect().height - 16)
                } catch (e) {
                  return;
                } finally {
                  event.preventDefault();
                }
              }}>Show me what you got</a>
            <footer>
<span className="github-btn github-btn-large"><a aria-label="Follow @jpdevries on GitHub" className="gh-btn" href="//github.com/jpdevries/" target="_blank"><span className="gh-ico" aria-hidden="true"></span><span className="gh-text">Follow @jpdevries</span></a></span>
            </footer>
          </div>

        </div>
        <div id="sticky" className="sticky" ref={(sticky) => this.sticky = sticky}>
          <a href="#cover" aria-label="Home">
            <Icon config={iconConfig} icon="jp" />
          </a>
          <label htmlFor="jump-to">
            <span>Jump to</span>
            <select name="jump-to" id="jump-to" onBlur={(event) => {
              try {
                const section = document.getElementById(this.state.section),
                header = section.querySelector('header').querySelector('h2,h3');
                header.setAttribute('tabindex', '-1');
                header.focus();

              } catch (e) { }
            }} onChange={(event) => {
              console.log(event.target.value, document.getElementById(event.target.value));
              const section = document.getElementById(event.target.value);
              try {

                this.scrollTo(section.getBoundingClientRect().top - this.sticky.getBoundingClientRect().height - 16)
              } catch (e) {
                console.error(e);
                return false;
              } finally {
                event.preventDefault();
                this.setState({
                  section: event.target.value
                })
                /*setTimeout(() => {
                  const header = section.querySelector('header').querySelector('h2,h3');
                  header.setAttribute('tabindex', '-1');
                  header.focus();
                }, 1200);*/
              }
            }}>
              <option>&nbsp;</option>
              <option value="accessibility">Accessibility</option>
              <option value="contact">Contact</option>
              <option value="consulting">Consulting</option>
              <option value="markuptips">Markup.Tips</option>
              <option value="mentoring">Mentoring</option>
              <option value="musings">Musings</option>
              <option value="opensource">OpenSource</option>
              <option value="portfolio">Portfolio</option>
              <option value="resume">Resumé</option>
              <option value="screencasts">Screencasts</option>
              <option value="intro">Services</option>
              <option value="workshops">Workshops</option>
            </select>
          </label>
        </div>
        <section id="intro">
          <header>
            <h2><Icon config={iconConfig} icon="tags" /><br />Services</h2>
            <div className="balanced">
              <div className="legible">
                <p>Over the past 10 years I have bridged design and development by specializing in Graphic Design and Full&nbsp;Stack Web&nbsp;Development with a <strong><em>strong</em></strong> emphasis on reliable performance, speed, accessibility, and web&nbsp;standards.</p>
                <p>These days I specialize&nbsp;in<br /><a href="#creating-hyper-performant-react-apps">creating hyper performant React web&nbsp;apps</a>.</p>
              </div>
            </div>
          </header>

          <div className="fairly padded services">
            <div className="bordered grid">
              <section className="web-dev grid-area-a" style={{

              }}>
                <header>
                  <h3><Icon config={iconConfig} icon="code" />&ensp;Web Development</h3>
                </header>
                <ul className="bordered grid skills">
                  <li className="grid-area-a" title="Babel">
                    <Icon config={iconConfig} icon="babel" />
                    <span className="visually-hidden">Babel</span>
                  </li>
                  <li className="grid-area-b" title="CSS3">
                    <Icon config={iconConfig} icon="css3" />
                    <span className="visually-hidden">CSS3</span>
                  </li>
                  <li className="grid-area-c" title="git">
                    <Icon config={iconConfig} icon="git" />
                    <span className="visually-hidden">git</span>
                  </li>
                  <li className="grid-area-d" title="Grunt">
                    <Icon config={iconConfig} icon="grunt" />
                    <span className="visually-hidden">Grunt</span>
                  </li>
                  <li className="grid-area-e" title="Gulp">
                    <Icon config={iconConfig} icon="gulp" />
                    <span className="visually-hidden">Gulp</span>
                  </li>
                  <li className="grid-area-f" title="Heroku">
                    <Icon config={iconConfig} icon="heroku" />
                    <span className="visually-hidden">Heroku</span>
                  </li>
                  <li className="grid-area-g" title="HTML5">
                    <Icon config={iconConfig} icon="html5" />
                    <span className="visually-hidden">HTML5</span>
                  </li>
                  <li className="grid-area-h" title="JavaScript">
                    <Icon config={iconConfig} icon="js" />
                    <span className="visually-hidden">JavaScript</span>
                  </li>
                  <li className="grid-area-i" title="PostgreSQL">
                    <Icon config={iconConfig} icon="postgresql" />
                    <span className="visually-hidden">PostgreSQL</span>
                  </li>

                  <li className="grid-area-j" title="MySQL">
                    <Icon config={iconConfig} icon="mysql" />
                    <span className="visually-hidden">MySQL</span>
                  </li>
                  <li className="grid-area-k" title="PHP">
                    <Icon config={iconConfig} icon="php" />
                    <span className="visually-hidden">PHP</span>
                  </li>
                  <li className="grid-area-l" title="MODX">
                    <Icon config={iconConfig} icon="modx" />
                    <span className="visually-hidden">MODX</span>
                  </li>
                  <li className="grid-area-m" title="jQuery">
                    <Icon config={iconConfig} icon="jquery" />
                    <span className="visually-hidden">jQuery</span>
                  </li>
                  <li className="grid-area-n" title="React">
                    <Icon config={iconConfig} icon="react" />
                    <span className="visually-hidden">React</span>
                  </li>
                  <li className="grid-area-o" title="Sass">
                    <Icon config={iconConfig} icon="sass" />
                    <span className="visually-hidden">Sass</span>
                  </li>
                  <li className="grid-area-p" title="TypeScript">
                    <Icon config={iconConfig} icon="typescript" />
                    <span className="visually-hidden">TypeScript</span>
                  </li>
                  <li className="grid-area-q" title="webpack">
                    <Icon config={iconConfig} icon="webpack" />
                    <span className="visually-hidden">webpack</span>
                  </li>
                  <li className="grid-area-r" title="NodeJS">
                    <Icon config={iconConfig} icon="nodejs" />
                    <span className="visually-hidden">NodeJS</span>
                  </li>
                </ul>
              </section>
              <section className="graphic-design grid-area-b">
                <header>
                  <h3><Icon config={iconConfig} icon="graduation-cap" />&ensp;Graphic Design</h3>
                </header>
                <ul className="bordered grid skills">
                  <li className="grid-area-a" title="Apple">
                    <p className="legible">
                      Bachelor of Science Degree in Graphic&nbsp;Design
                    </p>
                  </li>
                  <li className="grid-area-b" title="Photoshop">
                    <Icon config={iconConfig} icon="photoshop" />
                    <span className="visually-hidden">Photoshop</span>
                  </li>
                  <li className="grid-area-c" title="Illustrator">
                    <Icon config={iconConfig} icon="illustrator" />
                    <span className="visually-hidden">Illustrator</span>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </section>





        <section id="portfolio" className="portfolio">
          <header>
            <h2>
              <Icon config={iconConfig} icon="jp" /><br />
              Portfolio
            </h2>
          </header>
          <div className="fairly padded portfolio">
            <div className="bordered grid">
              <div className="grid-area-a">
                <a href="https://github.com/jpdevries/eureka#eureka-" target="_eureka">
                  <h3>
                    <Icon icon="tree" /><br />Eureka Media&nbsp;Browser
                  </h3>
                  <p className="legible">A mobile&ndash;first and inclusively designed media browser; progressively enhanced with React and server side rendering provided by a Nope/Express&nbsp;backend</p>
                  <code>#react #redux #node #a11y</code>
                </a>
              </div>
              <div className="grid-area-b">
                <a href="https://github.com/jpdevries/a11y-datagrid#demo" target="_datagrid">
                  <h3><Icon icon="table" /><br />Accessible Data&nbsp;Grid</h3>
                  <p className="legible">With plain HTML, mobile, keyboard, and screen reader support this is a progressively enhanced data grid anyone can&nbsp;use</p>
                  <code>#react #redux #a11y</code>
                </a>
              </div>
              <div className="grid-area-c">
                <a href="https://github.com/jpdevries/makeanico#makeanico" target="_makeanico">
                  <h3><Icon icon="cube" /><br />Makeanico</h3>
                  <p className="legible">Weighing in at under 10kB, this progressively enhanced web app enables anyone to create a 16x16 favicon.ico&nbsp;graphic</p>
                  <code>#10kapart #a11y #vanillajs</code>
                </a>
              </div>
            </div>
          </div>

        </section>

        <section id="consulting" className="consulting">
          <header>
            <h2><Icon config={iconConfig} icon="phone" /><br />Consulting</h2>
            <p className="legible">Front End or Back End, design or development, guidance is just a consult&nbsp;away.</p>
            <a href="mailto:mail@devries.jp?subject=Consulting" className="balanced button">
              <Icon config={iconConfig} icon="paper-plane" />&ensp;Schedule a&nbsp;consult
            </a>
          </header>
        </section>

        <section id="modmore" className="modmore">
          <header>
            <h2>
              <Icon icon="modmore" /><br />
              mod<strong>more</strong>
            </h2>
          </header>

          <div>
            <h3><a href="https://www.modmore.com/extras/redactor/?via=2" target="_modmoreredactor">Redactor for&nbsp;MODX</a></h3>
            <p className="legible">This commercial WYSIWYG editor brings you a lightweight & user friendly MODX editing&nbsp;experience</p>
            <code>#MODX #PHP #modmore</code>
          </div>

        </section>

        <section id="resume">
          <header>
            <h2><Icon config={iconConfig} icon="briefcase" /><br />Resumé</h2>
            <a download href="assets/pdf/devries_resume.pdf" className="balanced button"><Icon config={iconConfig} icon="download" />&ensp;PDF Download</a>
          </header>

        </section>

        <div className="dim flexibly balanced">
          <aside className="comfortable note">
            <p className="operator-screensmart-medium-italic"><Icon config={iconConfig} icon="handshake-o" /><br />We’re in luck. I’m currently accepting contracts for Web&nbsp;Development &amp;&nbsp;Consulting.</p>
            <a href="mailto:mail@devries.jp?subject=Contract%20Work" className="button operator-screensmart-bold">Hire Me</a>
          </aside>
        </div>
        <section id="mentoring">
          <header>
            <h2><Icon config={iconConfig} icon="thinkful" /><br />Mentoring</h2>
            <div className="balanced">
              <div className="legible">
                <p>My experience as an educator began in 2009 as a College Professor at the Art Institute of Portland. Today, as a <a href="https://www.thinkful.com/mentors/" target="_mentors">coding bootcamp mentor at Thinkful</a> I have the priveledge of guiding dozens of Web Development students along their journey.  I believe the best way to master a skill is to teach it. Through my students, I have learned more about myself, my craft, and my aspirations as an architect of the world&nbsp;wide&nbsp;web.</p>
              </div>
            </div>
          </header>
        </section>
        <section id="musings">
          <header>
            <h2>
              <Icon config={iconConfig} icon="medium" /><br />
              Musings
            </h2>
          </header>
          <div className="fairly padded musings">
            <div className="bordered grid">
              <div className="grid-area-a">
                <h3><a href="https://medium.com/front-end-hacking/preparing-react-components-for-server-side-rendering-18901d09784c">Preparing React Components for Server&ndash;Side&nbsp;Rendering</a></h3>
              </div>
              <div className="grid-area-b">
                <h3><a href="https://medium.com/@jpdevries/count-the-clicks-60719720f88b" target="_countclicks">Count the “Clicks”</a></h3>
              </div>
              <div className="grid-area-c">
                <h3>
                  <a href="chttps://medium.com/front-end-hacking/give-your-forms-some-form-2ec73cb36981" target="_formsform">Give your Forms some Form</a>
                </h3>
              </div>
              <div className="grid-area-d">
                <h3>
                  <a href="https://medium.com/markuptips/css-is-important-960a9921e454">CSS is !important</a>
                </h3>
              </div>
              <div className="grid-area-e">
                <h3>
                  <a href="https://medium.com/markuptips/unfolding-critical-css-91619401b4e">Unfolding Critical CSS</a>
                </h3>
              </div>
              <div className="grid-area-f">
                <h3>
                  <a href="https://medium.com/markuptips/let-us-learn-from-wordpress-28b0803530d8">Let us Learn from Wordpress</a>
                </h3>
              </div>
              <div className="grid-area-g">
                <h3>
                  <a href="https://modx.today/posts/2016/02/accessibility-is-water" target="_a11ywater">Accessibility is Water</a>
                </h3>
              </div>
              <div className="grid-area-h">
                <h3>
                  <a href="https://modx.today/posts/2016/11/love-what-you-do" target="_lovewhatyoudo">Love What You Do</a>
                </h3>
              </div>
              <div className="grid-area-i">
                <h3>
                  <a href="https://modx.today/posts/2015/06/breaking-modx-for-everyone" target="_breaking-modx">Breaking MODX for&nbsp;Everyone</a>
                </h3>
              </div>
            </div>
          </div>
        </section>
        <section id="opensource" className="opensource">
          <header>
            <h2><Icon config={iconConfig} icon="github" /><br />Open Source</h2>
          </header>
          <div className="balanced">
            <div className="legible">
              <p>I enjoy <a href="https://github.com/pulls?q=is%3Apr+author%3Ajpdevries+is%3Acopen" target="_jpprs">contributing to various open source&nbsp;projects</a>; afterall open software is what makes the world&nbsp;go&nbsp;around.</p>
            </div>
          </div>
          <section>
            <header>
              <h3>MODX Next Setup</h3>
            </header>
            <a href="https://jpdevries.github.io/modx-setup/" target="_modx-setup" aria-label="Take the MODX Next Setup Demo for a spin" title="Take the MODX Next Setup Demo for a spin">
              <img src="assets/img/opensource/modx-setup.png" alt="MODX Next Setup Design"/>
            </a>
            <footer>
              <details open>
                <summary aria-label="MODX Setup Details">Details</summary>
                <div className="balanced">
                  <div className="legible">
                    <p>This all&ndash;new MODX concept originated at the MODX Meetup in Malta and aims to make the unboxing experience of MODX more accessible to end&nbsp;users. <a aria-label="Take the all new MODX Setup concept for a spin" href="https://jpdevries.github.io/modx-setup/" target="_modx-setup">Take it for a&nbsp;spin</a>.</p>
                  </div>
                </div>
              </details>
            </footer>
          </section>
          <section id="datagrid">
            <h3>Accessible Data Grid</h3>
            <a href="https://github.com/jpdevries/a11y-datagrid#demo" target="_datagrid" aria-label="Try out the React Data Grid component" title="Try out the React Data Grid component">
              <img src="assets/img/opensource/datagrid.png" alt="MODX Next Setup Design"/>
            </a>
            <footer>
              <details open>
                <summary aria-label="MODX Setup Details">Details</summary>
                <div className="balanced">
                  <div className="legible">
                    <p>This mobile&ndash;first data grid meets accessibility success criteria while being progressively enhanced with&nbsp;React/Redux. It aspires to one day be found within the popular MODX Content Management&nbsp;System.</p>
                  </div>
                </div>
              </details>
            </footer>
          </section>
        </section>
        <section id="accessibility" className="">
          <header>
            <h2><Icon config={iconConfig} icon="universal-access" /><br />Accessibility</h2>
          </header>
          <div className="balanced">
            <div className="legible">
              <p>Each day I work towards a web for everyone by studying accessibile inclusive design patterns, mentoring&nbsp;students.</p>
              <a href="mailto:mail@devries.jp?subject=Accessibility%20Consultation" className="button">Schedule an Accessibility&nbsp;Consult</a>
            </div>
          </div>
        </section>

        <section id="markuptips" className="markuptips">
          <header>
            <h2><Icon config={iconConfig} icon="code" /><br />Markup.Tips</h2>
            <p>Over at <a href="https://markup.tips">Markup.Tips</a> I share tools, tips, and&nbsp;components.</p>
          </header>
          <div className="fairly padded portfolio">
            <div className="bordered grid">
              <div className="grid-area-a">
                <h3><a href="https://www.thinkful.com/projects/silence-your-css-footprint-with-sass-silent-classes-457" target="_silentsass">Silence Your CSS Footprint<br />With Sass Silent Classes</a></h3>
                <code>#scss</code>
              </div>
              <div className="grid-area-b">
                <h3><a href="https://markup.tips/blog/2015/animating-svg-artwork-with-canvas-and-vanillajs.html#focus" target="_canvasvanillajs">Animating SVG Artwork with &lt;canvas&gt; &amp;&nbsp;VanillaJS</a></h3>
                <code>#svg #canvas #vanillajs</code>
              </div>
              <div className="grid-area-c">
                <h3><a href="https://markup.tips/projects/grunting-icons-into-svg-sprites.html#focus" target="_gruntingicons">Grunting Icons into SVG Sprites</a></h3>
                <code>#node #grunt #svg #a11y</code>
              </div>
              <div className="grid-area-d">
                <h3><a href="https://markup.tips/projects/thinkful-bringing-svg-graphics-to-life-with-react.html#focus" target="_svglife">Bringing SVG Graphics to Life with React</a></h3>
                <code>#react #svg</code>
              </div>
            </div>
          </div>
        </section>

        <section id="workshops" className="screencasts workshops">
        <header>
          <h2><Icon config={iconConfig} icon="users" /><br />Workshops</h2>
        </header>
        <div className="fairly padded">
          <div className="flexible balanced">
            <div id="creating-hyper-performant-react-apps" className="balanced video grid-area-a">
              <header>
                <h3>Creating Hyper Performant Web Apps with&nbsp;React
</h3>
                <code>#youtube</code>
              </header>
              <YouTube
                videoId={'Nu9-ea75GzQ'}                  // defaults -> null
                id={'Nu9-ea75GzQ'}                       // defaults -> null
                className={'video'}                // defaults -> null
              />
            </div>
          </div>
        </div>
        </section>
        <section id="screencasts" className="screencasts">
          <header>
            <h2><Icon config={iconConfig} icon="video-camera" /><br />Screencasts</h2>
          </header>
          <div className="fairly padded">
            <div className="grid">
              <div className="balanced video grid-area-a">
                <header>
                  <h3>MODX Create Resource&nbsp;Concept</h3>
                  <code>#MODX #vanillajs</code>
                </header>

                <Vimeo videoId={ 219024629 } />
              </div>
              <div className="balanced video grid-area-b">
                <header>
                  <h3>All&ndash;new MODX Setup&nbsp;Concept</h3>
                  <code>#MODX #a11y</code>
                </header>
                <Vimeo videoId={ 218397030 } />
              </div>
              <div className="balanced video grid-area-c">
                <header>
                  <h3>MODX Setup&nbsp;Permissions</h3>
                  <code>#MODX #a11y</code>
                </header>
                <Vimeo videoId={ 217647956 } />
              </div>
              <div className="balanced video grid-area-d">
                <header>
                  <h3>Saving Data with the Save Data&nbsp;Header</h3>
                  <code>#a11y</code>
                </header>
                <Vimeo videoId={ 215494474 } />
              </div>
              <div className="balanced video grid-area-e">
                <header>
                  <h3>Architecting a Futuristic MODX&nbsp;Manager</h3>
                  <code>#MODX #design</code>
                </header>
                <Vimeo videoId={ 195648795 } />
              </div>
              <div className="balanced video grid-area-f">
                <header>
                  <h3>Manage Users&nbsp;CMP</h3>
                  <code>#MODX #react</code>
                </header>
                <Vimeo videoId={ 176084699 } />
              </div>
              <div className="balanced video grid-area-g">
                <header>
                  <h3>Benefits of Designing HTML&ndash;first</h3>
                  <code>#HTML5 #design #a11y #seo</code>
                </header>
                <Vimeo videoId={ 189324043 } />
              </div>
            </div>
          </div>

        </section>

        <section id="slides" className="slides">
          <header>
            <h2><Icon icon="pie-chart" /><br />Slides</h2>
            <div className="fairly padded">
              <div className="grid">
                  <div className="grid-area-a" aria-label="All Users are Disabled Slides">
                    <iframe src="//www.slideshare.net/slideshow/embed_code/key/10epvu5rJjFDKO" width="595" height="485" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" allowFullScreen> </iframe>
                  </div>
                  <div className="grid-area-b" aria-label="Responsibly Architecting the World Wide Web Slides">
                    <iframe src="//www.slideshare.net/slideshow/embed_code/key/y6YCU1jVSjwPtz" width="595" height="485" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" allowFullScreen> </iframe>
                  </div>
              </div>
            </div>
          </header>
        </section>

        <section id="contact" className="contact">
          <header>
            <h2><Icon config={iconConfig} icon="envelope-o" /><br />Contact</h2>
            <p className="legible">My inbox is always&nbsp;open.</p>
            <a href="mailto:mail@devries.jp?subject=Consulting" className="balanced button">
              <Icon config={iconConfig} icon="paper-plane" />&ensp;Drop me a&nbsp;line
            </a>
          </header>
        </section>

        <footer role="contentinfo">
          <div className="App-header">
            <div className="hello">
              <img src="assets/img/logo.svg" className="App-logo" alt="JP Logo" />
              <h2 style={{marginTop: '3rem'}}>That’s all for now folks.</h2>

              <a href="#intro" className="comfortable balanced button" onClick={(event) => {
                try { 
                  this.scrollTo(document.getElementById('cover').getBoundingClientRect().top - this.sticky.getBoundingClientRect().height - 16)
                } catch (e) {
                  return;
                } finally {
                  event.preventDefault();
                }
                }}>Back to top&ensp;<Icon config={iconConfig} icon="arrow-circle-up" /></a>
              <footer>
                <span className="github-btn github-btn-large"><a aria-label="Follow @jpdevries on GitHub" className="gh-btn" href="//github.com/jpdevries/" target="_blank"><span className="gh-ico" aria-hidden="true"></span><span className="gh-text">Follow @jpdevries</span></a></span>
              </footer>
            </div>

          </div>
        </footer>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js